export enum ValidationMessages {
    REQUIRED = "This field is required",
    MULTIPLE_REQUIRED = "Some required fields are missing",
    EMPTY = ""
  }
  